<template>
  <div class="grid" />
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
@use "@qmulus/primevue-theme/theme-variables.scss";

.grid {
  background-color:  theme-variables.$shade000 ;
  background-image:
    repeating-linear-gradient(0deg, theme-variables.$shade200 0, theme-variables.$shade200 1px, transparent 1px, transparent 40px),
    repeating-linear-gradient(90deg, theme-variables.$shade200 0, theme-variables.$shade200 1px, transparent 1px, transparent 40px);
}
</style>
